/**
 * Yangi deploy'dan keyin ochiq tablar eski JS bilan qolmasin (2026-10-18: eski bundle yangi API'dan `scope_teams` kutib
 * yiqildi). Build vaqtida `version.json` (build id) chiqariladi; ilova uni fonda tekshiradi -- WebSocket qayta ulanganda
 * (deploy backend'ni qayta ko'taradi), tab ko'rinadigan bo'lganda va har 5 daqiqada. Yangi build bo'lsa: tab yashirin
 * bo'lsa darhol yangilanadi, ko'rinib tursa "Yangilash" tugmali xabar chiqadi va keyingi sahifa almashishida yangilanadi.
 * Xato sahifasi (AppError) ham avval shuni tekshiradi: eski bundle bo'lsa o'zi yangilanadi (bir marta).
 */
import i18n from "i18next";
import { toast } from "@/components/ui/toast";

export const BUILD_ID: string = typeof __BUILD_ID__ === "string" ? __BUILD_ID__ : "dev";

let stale = false;
let notified = false;

export function isStale(): boolean {
  return stale;
}

/** Yangi build topilganda nima qilinadi: tab yashirin bo'lsa jimgina yangilash, ko'rinib tursa xabar */
export function staleAction(visibility: DocumentVisibilityState): "reload" | "notify" {
  return visibility === "hidden" ? "reload" : "notify";
}

export async function checkVersion(): Promise<boolean> {
  if (import.meta.env.DEV) return false;
  try {
    const res = await fetch(`/version.json?_=${Date.now()}`, { cache: "no-store", credentials: "same-origin" });
    if (!res.ok) return false;
    const data = (await res.json()) as { build?: string };
    if (data.build && data.build !== BUILD_ID) markStale();
  } catch {
    /* tarmoq yo'q -- keyingi tekshiruvda */
  }
  return stale;
}

export function markStale() {
  stale = true;
  if (staleAction(document.visibilityState) === "reload") {
    window.location.reload();
    return;
  }
  if (notified) return;
  notified = true;
  toast("info", i18n.t("update.title"), i18n.t("update.desc"), 10 * 60_000, { label: i18n.t("update.reload"), onClick: () => window.location.reload() });
}

/** Bir marta yangilash (xato sahifasidan): aylanib qolmasin -- shu build uchun bir daqiqada bir marta */
export function reloadOnce(): boolean {
  const key = `dh.reloaded.${BUILD_ID}`;
  try {
    const last = Number(sessionStorage.getItem(key) ?? 0);
    if (Date.now() - last < 60_000) return false;
    sessionStorage.setItem(key, String(Date.now()));
  } catch {
    /* maxfiy rejim: baribir yangilaymiz */
  }
  window.location.reload();
  return true;
}

export function startVersionWatch() {
  if (import.meta.env.DEV) return;
  window.setInterval(() => void checkVersion(), 5 * 60_000);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      if (stale) window.location.reload();
    } else {
      void checkVersion();
    }
  });
}
